import React from 'react';


const mainPoint = {listStyleType: "none", padding: "0"};
const mainDescription = {paddingLeft: "10px"};
const secondaryPoint = {listStyleType: "none"};

export default function FaqPage() {
	return (
		<section id="body">
			<div className="container">
				<div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white fw-bold">Frequently Asked Questions</h2>
					</div>
				</div>
				<div className="row content">
					<div className="col-1"></div>
					<div className="col-10 shadow bg-white rounded">
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">1.</label>
								<label className="col-10 col-form-label">
									What are the benefits and premiums of this product?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									The Personal Cyber Insurance (PCI) policy is designed to cover you for financial or material losses arising directly from any unexpected cyber threats or events. The insured events and premiums are as outlined below:
									<div style="overflow-x: auto;">
										<table className='table table-bordered table-responsive'>
											<thead>
												<tr>
													<th rowSpan={2}  style={{verticalAlign: "top"}} width={'50%'}>
														INSURED EVENTS<br/>
														<i style={{fontWeight: "normal"}}>(for which you are covered)</i>
													</th>
													<th colSpan={3} className='text-center'>
														LIMIT OF COVER 
													</th>
												</tr>
												<tr>
													<th className='text-center'>Plan 1</th>
													<th className='text-center'>Plan 2</th>
													<th className='text-center'>Plan 3</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>
														<ol style={mainPoint}>
															<li>1.1	
																<span style={mainDescription}>Electronic Fund Transfer Fraud</span>
															</li>
															<ul style={secondaryPoint}>
																<li>
																(reimburse you for your financial loss arising directly from a cyber event, which you first discovered during the policy period)
																</li>
															</ul>
														</ol>
													</td>
													<td className='text-center'>RM 2,500</td>
													<td className='text-center'>RM 5,000</td>
													<td className='text-center'>RM 10,000</td>
												</tr>
												<tr>
													<td>
														<ol style={mainPoint}>
															<li>1.2	
																<span style={mainDescription}>Online Retail Fraud</span>
															</li>
															
														</ol>
													</td>
													<td className='text-center'>RM 1,000</td>
													<td className='text-center'>RM 2,500</td>
													<td className='text-center'>RM 5,000</td>
												</tr>

												<tr>
													<td>
														<ol style={mainPoint}>
															<li>1.3
																<span style={mainDescription}>Identity Theft</span>
															</li>
															<ul style={secondaryPoint}>
																<li>
																(reimburse you for identify theft expenses arising directly from an identity theft, which you first discovered during the policy period)
																</li>
															</ul>
														</ol>
													</td>
													<td className='text-center'>RM 500</td>
													<td className='text-center'>RM 1,000</td>
													<td className='text-center'>RM 2,000</td>
												</tr>

												<tr>
													<td>
														<ol style={mainPoint}>
															<li>1.4
																<span style={mainDescription}>Cyber Bullying</span>
															</li>
															<ul style={secondaryPoint}>
																<li>
																(reimburse you for your cyber bullying expenses arising directly from cyber bullying that is first made against you in your personal capacity, during the policy period)
																</li>
															</ul>
														</ol>
													</td>
													<td className='text-center'>RM 3,000</td>
													<td className='text-center'>RM 6,000</td>
													<td className='text-center'>RM 9,000</td>
												</tr>

												<tr>
													<td>
														<ol style={mainPoint}>
															<li>1.5
																<span style={mainDescription}>E-Commerce Purchase Protection</span>
															</li>
															<ul style={secondaryPoint}>
																<li>
																(reimburse you for your material loss arising directly from non-delivery, accidental damage or theft of the product you purchased online during the policy period)
																</li>
															</ul>
														</ol>
													</td>
													<td className='text-center'>RM 1,000</td>
													<td className='text-center'>RM 2,500</td>
													<td className='text-center'>RM 5,000</td>
												</tr>

												<tr>
													<td className='text-end'>
														<span style={{fontWeight: "bold"}}>GROSS PREMIUM</span><br/>
														(subject to the applicable Service Tax and Stamp Duty)
													</td>
													<td className='text-center' style={{fontWeight: "bold"}}>RM 65.00</td>
													<td className='text-center' style={{fontWeight: "bold"}}>RM 125.00</td>
													<td className='text-center' style={{fontWeight: "bold"}}>RM 230.00</td>
												</tr>
												
											</tbody>
										</table>
									</div>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">2.</label>
								<label className="col-10 col-form-label">
									What are the eligibility criteria to purchase this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									You must be 18 years old and above, as well as a Malaysian, to be eligible to purchase this policy.
								</label>
							</div>
						</div>

						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">3.</label>
								<label className="col-10 col-form-label">
									What is the geographical scope covered?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The coverage under this policy is on worldwide basis.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">4.</label>
								<label className="col-10 col-form-label">
									How to enroll for this product?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								You may purchase the Personal Cyber Insurance online via the instaPol website. There is a 72-hour timeframe for sanction screening before the commencement of the policy. Alternatively, you may enrol directly at any of the customers’ counter services at The Pacific Insurance Berhad.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">5.</label>
								<label className="col-10 col-form-label">
									What are the modes of payment?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								You can pay by credit card, FPX or e-wallet. Please note that full gross premium must be paid and received by Howden Insurance Brokers Sdn. Bhd. or The Pacific Insurance Berhad.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">6.</label>
								<label className="col-10 col-form-label">What is the commission paid to agent/ intermediary?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								25% of the Gross Premium.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">7.</label>
								<label className="col-10 col-form-label">
									Can I upgrade or downgrade my plan during the Period of Insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								You can only upgrade or downgrade your purchased plan during the next renewal.
								</label>

							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">8.</label>
								<label className="col-10 col-form-label">
									What are the major exclusions under this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								This policy does not cover abnormal conditions/ state of emergency/ mass cyber-attack, bodily injury, business activities, confidence scams, digital currency of any kind, any dishonest, criminal, malicious or fraudulent acts, indirect or consequential loss, infrastructure failure, lost or stolen plastic cards, and so on. You may refer to the policy contract for the full list of exclusions applicable in this policy.
							</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">9.</label>
								<label className="col-10 col-form-label">Can I cancel the policy, and will there be any refund of premium?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Yes, if cancellation is on your request, a 75% refund of the pro-rata premium equal to the unexpired period of this policy is payable, provided no claim has arisen during the policy period. For this, a seven (7) days prior written notice is required.

								<br/><br/>
								If cancellation is necessary arising from the specific condition(s) mentioned in the policy, where we have initiated the cancellation by giving you at least seven (7) days prior notice in writing, we will then return promptly any premium actually paid by you, provided no claim has arisen during the policy period.
								
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">10.</label>
								<label className="col-10 col-form-label">
									When and why should I contact the Incident Responder?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									As soon as you become aware of any fact or circumstances that is reasonably likely to result in a loss covered under this policy, you must contact our <strong>Incident Responder (helpline: +603-40657083 and/or email to <a href="mailto:customercare@dbglobal.co">customercare@dbglobal.co</a>)</strong> within 72 hours after the fact or circumstances was first discovered.
									
									<br/><br/>
									Our Incident Responder will provide advice on how to remediate and prevent further escalation of any cyber events, access any expected loss arising from the said cyber event, determine the suitability for claims, and advice you on claims procedures and how to file a claim.
									
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">11.</label>
								<label className="col-10 col-form-label">How to make a claim?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								In the event of a claim, or that you become aware of any act or circumstances likely to result in a loss, you must notify The Pacific Insurance Berhad as soon as possible, and it is important for you to call our <strong> HELPLINE: +603-40657083 and/or email to <a href="mailto:customercare@dbglobal.co">customercare@dbglobal.co</a> (your Incident Responder appointed by us)</strong> within 72 hours after you are aware of the circumstances, so that necessary guidance could be provided to you on a timely basis. If a claim is apparent, you are to make a police report as soon as possible, preferably within 24 hours after the discovery.

								
								<br/><br/>
									You may also contact instaPol :
								
								<br/><br/>
									<div class="row d-block d-lg-none">
										<div class="col-12 text-left p-0">
											<strong>Customer Service Careline</strong>
										</div> 
										<div class="col-12 mb-3 text-left p-0">
											+60122606183 <br/>
											Monday to Friday <br/>
											8:45 am to 5:45 pm
										</div> 

										<div class="col-12 text-left p-0">
											<strong>WhatsApp No.</strong>
										</div> 
										<div class="col-12 mb-3 text-left p-0">
											+60122606183
										</div> 

										<div class="col-12 text-left p-0">
											<strong>Email</strong>
										</div> 
										<div class="col-12 mb-3 text-left p-0">
											<a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a>
										</div> 

									</div>	
									<table className='d-none d-lg-block table table-responsive' style={{width: "80%"}}>
										<tr>
											<td><strong>Customer Service Careline</strong></td>
											<td>
												+60122606183 <br/>
												Monday to Friday <br/>
												8:45 am to 5:45 pm
											</td>
										</tr>
										<tr>
											<td><strong>WhatsApp No.</strong></td>
											<td>
												+60122606183
											</td>
										</tr>
										<tr>
											<td><strong>Email</strong></td>
											<td>
												<a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a>
											</td>
										</tr>
										
										
									</table>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">12.</label>
								<label className="col-10 col-form-label">Can the policy be automatically renewed upon expiry?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The duration of cover for this policy is one year and renewal is not automatic. You have the option to renew your insurance policy through the instaPol website in order to continue enjoying the coverage.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">13.</label>
								<label className="col-10 col-form-label">Can the Insured Person purchase more than one Personal Cyber Insurance policy?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The Insured Person can only purchase one policy under this Personal Cyber Insurance.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">14.</label>
								<label className="col-10 col-form-label">Is there any after sales & claims services offered to customer after insurance purchase?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance. Alternatively, you may also contact your chosen insurance company or takaful operator.
								
								</label>
							</div>
						</div>

						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center"></label>
								<label className="col-10 col-form-label">
								Disclaimer for FAQ
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The FAQs compiled herein are merely informational and not intended to be construed as a contract of insurance. While every effort has been made to ensure that the information contained herein is accurate and up to date, this is not always possible. Please refer to actual policy for exact terms and conditions of the insurance product that you are purchasing.
								
								</label>
							</div>
						</div>
						
					</div>
					<div className="col-1"></div>
				</div>
			</div>
				
			<div className="row footer my-5">
				<div className="col-md-1"></div>
				<div className="col-12 col-md-10 text-end">
					<a className="btn btn-success me-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/cyber">Get Quote</a>
				</div>
				<div className="col-md-1"></div>
			</div>
		</section>
	);
}